import React, { useState } from 'react';
import { styled } from '@linaria/react';
import { Flex } from '@vio/atlas/helpers/Flex';
import { Pill } from '@vio/atlas/Pill';
import { SkeletonLoader } from '@vio/atlas/SkeletonLoader';
import { TranslatedCity } from 'components/CarouselWidgets/TopDealsForTonight/utils';
interface Props {
  items: TranslatedCity[];
  onPillClick: (index: number) => void;
  isActive: boolean;
}
const _exp = /*#__PURE__*/() => Flex.Row;
const ScrollableWrapper = /*#__PURE__*/styled(_exp())({
  name: "ScrollableWrapper",
  class: "s79fzjw",
  propsAsIs: true
});
const CitiesGroupSkeleton = () => {
  return <ScrollableWrapper>
      {[...Array(4)].map((_, index) => <SkeletonLoader key={`skl_${index}`} width={80} height={34} />)}
    </ScrollableWrapper>;
};
export const CitiesGroup = ({
  items,
  onPillClick,
  isActive
}: Props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const handleClick = (index: number) => () => {
    if (!isActive) return;
    if (index !== activeIndex) {
      setActiveIndex(index);
      onPillClick?.(index);
    }
  };
  if (!items.length) return <CitiesGroupSkeleton />;
  return <ScrollableWrapper>
      {items.map((item, index) => <Pill key={item.name} variant="default" isSelected={index === activeIndex} onClick={handleClick(index)}>
          {item.name}
        </Pill>)}
    </ScrollableWrapper>;
};

require("./CitiesGroup.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./CitiesGroup.tsx");